import { render, staticRenderFns } from "./CalcDropshippers.vue?vue&type=template&id=68d952f1&scoped=true"
import script from "./CalcDropshippers.vue?vue&type=script&lang=js"
export * from "./CalcDropshippers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d952f1",
  null
  
)

export default component.exports